import { render, staticRenderFns } from "./DamageView.vue?vue&type=template&id=230e0506&scoped=true&"
import script from "./DamageView.vue?vue&type=script&lang=js&"
export * from "./DamageView.vue?vue&type=script&lang=js&"
import style0 from "./DamageView.vue?vue&type=style&index=0&id=230e0506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230e0506",
  null
  
)

export default component.exports